const doc = [({"da":({"activerecord":({"attributes":({"user_element":({"file":"Fil"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;